import React from 'react';
import { RhDateInput } from '../../../../../../../dum';
import { IOrderSale } from '../../order-sale-form';
import { usePrefillFromClientAccount } from '../../use-prefill-from-client-account';
import {
    ORDER_SALE_FIELD_LABELS,
    shortLabel,
} from '../../../../../../../../helpers';

// On create, changing the sale date recomputes the expected payment date from
// the selected client's credit days. On edit, the loaded payment date is kept.
export function SaleDateInput() {
    const { recomputePaymentDate } = usePrefillFromClientAccount();

    return (
        <RhDateInput
            name={'date'}
            label={shortLabel(ORDER_SALE_FIELD_LABELS.date)}
            onChange={(val) => recomputePaymentDate(val as IOrderSale['date'])}
        />
    );
}
